import { TotpSessionKey } from '../Constants'
import { removeSessionStorage } from './Session'

//logout sessions and other before logout
export const ClearSessionOnSignOut = () => {
  removeSessionStorage(TotpSessionKey)
}
